import {slideUp, slideDown} from 'es6-slide-up-down';
import findAncestor from "./findAncestor";

export default () => {
    const header = document.querySelector('[data-header]');
    const hamburger = document.querySelector('[data-hamburger]');
    const navigation = document.querySelector('[data-navigation]');
    const navLinks = document.querySelectorAll('.header__navigation__link');

    function stickyNavClass() {
        if (window.scrollY > 220) {
            header.classList.add('stick');
        } else {
            header.classList.remove('stick');
        }
    }


    if (hamburger) {
        hamburger.addEventListener('click', (e) => {
            e.preventDefault();
            if (hamburger.classList.contains('active')) {
                hamburger.classList.remove('active');
                navigation.classList.remove('active');
            } else {
                hamburger.classList.add('active');
                navigation.classList.add('active');
            }
            return false;
        });
    }

    for (const link of navLinks) {
        const icon = link.querySelector('[data-subnav]');
        if (!icon) {
            continue;
        }

        link.addEventListener('click', (e) => {
            // Only hijack the click in mobile nav mode, where submenus are
            // click-to-expand accordions - on desktop they open on hover and
            // the title link should always navigate normally instead.
            //
            // We can't use icon.offsetParent here: CSS also shows this same
            // [data-subnav] icon on desktop for nested (third-level) flyout
            // submenus, so that check wrongly hijacked clicks on any second
            // -level item that has its own children (eg Ensuite Cabins under
            // Accommodation), breaking navigation on desktop entirely. The
            // hamburger button is a reliable mobile-vs-desktop signal instead,
            // since it's the one thing CSS hides on desktop unconditionally.
            if (!hamburger || hamburger.offsetParent === null) {
                return true;
            }

            e.preventDefault();
            const parent = findAncestor(link, 'li');
            const subNav = parent.querySelector('ul');
            if (subNav.classList.contains('active')) {
                slideUp(subNav, 500);
                subNav.classList.remove('active');
                icon.classList.remove('active')
            } else {
                slideDown(subNav, 500);
                subNav.classList.add('active');
                icon.classList.add('active')
            }
            return false;
        });
    }

    window.addEventListener('scroll', () => {
        stickyNavClass();
    });

}
